// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".mc_skeleton[data-v-7d16d4b3] {\n  position: fixed;\n  width: 100%;\n  height: 100%;\n  z-index: 99;\n  background: #fff;\n}\n.mc_skeleton .skeleton_pic[data-v-7d16d4b3] {\n  padding: 0;\n}\n.mc_skeleton[data-v-7d16d4b3] .van-skeleton__avatar--square {\n  width: 10rem !important;\n  margin: 0;\n}", ""]);
// Exports
module.exports = exports;
